import {ActionList} from '@primer/react'
import {FailureDialog} from '../FailureDialog'
import {StateIcon} from '../StateIcon'
import type {DefaultError, UseMutationResult} from '@github-ui/react-query'
import {announce} from '@github-ui/aria-live'
import {useClosePullRequestMutation} from '@github-ui/mergebox/use-close-pull-request-mutation'
import {useOptimisticPrStateCallbacks} from '../../hooks/use-invalidate-pr-state'

const mutateOptions = {onSuccess: () => announce('Pull request closed')}

export function useCloseActionMutation() {
  return useClosePullRequestMutation(useOptimisticPrStateCallbacks('CLOSED'))
}

export function CloseAction({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return (
    <ActionList.Item
      variant="danger"
      loading={mutation.isPending}
      onSelect={() => mutation.mutate(undefined, mutateOptions)}
    >
      <ActionList.LeadingVisual>
        <StateIcon state="CLOSED" />
      </ActionList.LeadingVisual>
      Close pull request
    </ActionList.Item>
  )
}

export function CloseFailureDialog({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return mutation.isError ? (
    <FailureDialog
      title="Failed to close pull request"
      message="An error occurred while closing this pull request. Please try again."
      details={mutation.error.message}
      onRetry={() => mutation.mutate(undefined, mutateOptions)}
      onDismiss={() => mutation.reset()}
    />
  ) : null
}
